var _defs, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonEffektivitetVarmevaxlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;stroke-miterlimit:10;stroke-width:14.17px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "260.67 576 457.14 190 505.68 190 309.21 576 260.67 576"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.26,384.61a83.09,83.09,0,1,1,83.09-83.09A83.19,83.19,0,0,1,271.26,384.61Zm0-129a46,46,0,1,0,46,46A46,46,0,0,0,271.26,255.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.24,547.18a83.09,83.09,0,1,1,83.09-83.09A83.18,83.18,0,0,1,496.24,547.18Zm0-129a46,46,0,1,0,46,46A46,46,0,0,0,496.24,418.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonEffektivitetVarmevaxlare);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-effektivitet-varmevaxlare.945c218a6ade0f02fae0dc2a8baef349.svg";
export { ForwardRef as ReactComponent };